"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = void 0;
exports.environment = {
    request: {
        apiVersion: '19.9.0',
        ottMode: false,
        fileFormatValue: 1
    },
    response: {
        nestedResponse: false,
        customErrorInHttp500: false
    }
};

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVudmlyb25tZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVlhLFFBQUEsV0FBVyxHQUFnQjtJQUNwQyxPQUFPLEVBQUU7UUFDTCxVQUFVLEVBQUUsUUFBUTtRQUNwQixPQUFPLEVBQUUsS0FBSztRQUNkLGVBQWUsRUFBRSxDQUFDO0tBQ3JCO0lBQ0QsUUFBUSxFQUFFO1FBQ04sY0FBYyxFQUFFLEtBQUs7UUFDckIsb0JBQW9CLEVBQUUsS0FBSztLQUM5QjtDQUNKLENBQUEiLCJmaWxlIjoiZW52aXJvbm1lbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgaW50ZXJmYWNlIEVudmlyb25tZW50IHtcbiAgICByZXF1ZXN0OiB7XG4gICAgICAgIGFwaVZlcnNpb246IHN0cmluZyxcbiAgICAgICAgb3R0TW9kZTogYm9vbGVhbixcbiAgICAgICAgZmlsZUZvcm1hdFZhbHVlOiBudW1iZXJcbiAgICB9XG4gICAgcmVzcG9uc2U6IHtcbiAgICAgICAgbmVzdGVkUmVzcG9uc2U6IGJvb2xlYW4sXG4gICAgICAgIGN1c3RvbUVycm9ySW5IdHRwNTAwOiBib29sZWFuXG4gICAgfTtcbn1cblxuZXhwb3J0IGNvbnN0IGVudmlyb25tZW50OiBFbnZpcm9ubWVudCA9IHtcbiAgICByZXF1ZXN0OiB7XG4gICAgICAgIGFwaVZlcnNpb246ICcxOS45LjAnLFxuICAgICAgICBvdHRNb2RlOiBmYWxzZSxcbiAgICAgICAgZmlsZUZvcm1hdFZhbHVlOiAxXG4gICAgfSxcbiAgICByZXNwb25zZToge1xuICAgICAgICBuZXN0ZWRSZXNwb25zZTogZmFsc2UsXG4gICAgICAgIGN1c3RvbUVycm9ySW5IdHRwNTAwOiBmYWxzZVxuICAgIH1cbn0iXX0=
